import createSelector from 'selectorator';

import type { ReduxStore } from '../store';

import type { NavigationState } from './types';

const NavigationSelectors = {
  get: createSelector<ReduxStore, NavigationState>(['navigation']),

  /**
   * Retrieves selected scanId from revision store.
   */
  getSelectedRevisionScanId: createSelector<ReduxStore, number | undefined>(['navigation'],
    (nav: NavigationState) => nav.navProps?.revision?.selectedRevisionScan?.id),
};

export default NavigationSelectors;
